import { createGlobalStyle } from 'styled-components'

export const GlobalInputs = createGlobalStyle`
  .react-tel-input{
     margin-bottom: 1rem;
     .country-list{
       margin-top: 0 !important;
     }
     .form-control{
        display: block;
        border-radius: 4px;
        border: 1px solid #e3e7ed;
        background-color: #f7f9fc;
        margin-left: 10%;
        width: 90%;
        height: 50px;
        padding: 0.75rem;
        font-size: 1rem;
        line-height: 1.5rem;
        color: #152735;
        background-clip: padding-box;
        transition: border-color 0.15s;
        box-sizing: border-box;
        ::placeholder {
          color: #b5b5b5;
        }
        :focus {
          border-color: #89919C;
          outline: 0;
        }
    }
    .selected-flag{
      width: 100%;
      margin-bottom: 1rem;
      border-radius: 4px;
      border-color: #89919C;
      :focus {
        border-color: #89919C;
        outline: 0;
        margin-bottom: 1rem;
        border-radius: 4px;
        background-color: #89919C;
      }
    }
    .flag-dropdown{
      width: 9%;
      margin-bottom: 1rem;
      border-radius: 4px;
      border: 1px solid #e3e7ed;
      height: 50px;
      :focus {
        border-color: #89919C;
        outline: 0;
        margin-bottom: 1rem;
        border-radius: 4px;
        background-color: #89919C;
         .selected-flag{
      width: 100%;
      margin-bottom: 1rem;
      border-radius: 4px;
      border-color: #89919C;
    }
      }
    }
  }
`
export default GlobalInputs
